import { render } from "./UserSignatureSettings.vue?vue&type=template&id=733a027e&scoped=true"
import script from "./UserSignatureSettings.vue?vue&type=script&lang=ts"
export * from "./UserSignatureSettings.vue?vue&type=script&lang=ts"

import "./UserSignatureSettings.vue?vue&type=style&index=0&id=733a027e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-733a027e"

export default script